module.exports = __webpack_public_path__ + "img/realLeaf3.fa00ebf5.png";